import { render, staticRenderFns } from "./Silder.vue?vue&type=template&id=dbdc0026&scoped=true&"
import script from "./Silder.vue?vue&type=script&lang=js&"
export * from "./Silder.vue?vue&type=script&lang=js&"
import style0 from "./Silder.vue?vue&type=style&index=0&id=dbdc0026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc0026",
  null
  
)

export default component.exports